import axios from 'axios';
import apisUrls from '../urls';

const getAllCountriesApi = (paramsFilter) => {
  return axios.get(apisUrls?.getCountries);
};

export default getAllCountriesApi;
